<template>
  <div class="bip">
    <navBar v-if="navigationbar" :text="$t('index.nav')"></navBar>
    <div class="bar_box" :class="navigationbar ? 'bar_box_active' : ''">
      <div class="bip_bar_box" v-if="headbar">
        <div
          class="bip_bar"
          :class="selectbar == 1 ? 'bip_bar_active' : ''"
          @click="bar(1)"
        >
          <div class="bip_bar_text">{{ $t("index.game") }}</div>
          <div class="bip_bar_tiao"></div>
        </div>
        <!-- <div
          class="bip_bar"
          :class="selectbar == 2 ? 'bip_bar_active' : ''"
          @click="bar(2)"
        >
          <div class="bip_bar_text">{{ $t("index.welfare") }}</div>
          <div class="bip_bar_tiao"></div>
        </div> -->
        <div
          class="bip_bar"
          :class="selectbar == 3 ? 'bip_bar_active' : ''"
          @click="bar(3)"
        >
          <div class="bip_bar_text">{{ $t("index.category") }}</div>
          <div class="bip_bar_tiao"></div>
        </div>
      </div>
    </div>
    <!-- v-show="selectbar == 1" -->
    <div v-show="selectbar == 1" class="main" @touchmove="Playtouchmove">
      <div class="game_box game_main" v-if="boxshow">
        <!--  :class="
            (headbar ? 'seek_box_top' : '',
            navigationbar ? 'seek_box_top_active' : '')
          " -->
        <!-- :class="navigationbar ? 'seek_box_top_active' : ''" -->
        <div :class="navigationbar ? 'seek_box_top_active' : ''">
          <!--  :class="headbar ? 'seek_box_top' : ''" -->
          <div class="seek_box" :class="headbar ? 'seek_box_top' : ''">
            <!-- <div class="user">
              <img
                class="user_img"
                @error="avatarError($event)"
                :src="userheader"
                alt="avatar"
              />
            </div> -->
            <router-link tag="div" to="/game_seek" class="seek">
              <div class="seek_url">
                <img class="seek_img" src="@/img/seek.png" />
              </div>
              <div class="seek_text">{{ $t("index.seek") }}</div>
            </router-link>
          </div>
        </div>

        <!--这个是玩过的游戏列表 -->
        <!-- <div class="recent_play" v-if="isPlayList.length > 0"> -->
        <div
          class="recent_play"
          v-show="getRecentPlayList(userInfo.id).length > 0"
          @click="onDebug()"
        >
          <div class="recent_play_title">{{ $t("index.history_title") }}</div>
          <div class="recent_play_box">
            <div
              class="recent_play_game"
              v-for="(item, index) in getRecentPlayList(userInfo.id)"
              @click="onPlay(item)"
              :key="index"
            >
              <img class="recent_play_img imgs" :src="item.imageSrc" alt="" />
            </div>
          </div>
        </div>
        <!-- 这个是游戏列表 -->
        <div class="game" v-if="GameList.length > 0">
          <div v-for="(item, i) in GameList" :key="i">
            <div class="" v-if="i == 0 && GameList.length > 3">
              <div class="game_list_box pd_le">
                <div class="game_list_title">{{ item.title }}</div>
              </div>
              <div class="most_box">
                <div class="most_game_box hidescrollbar">
                  <div
                    class="most_game"
                    v-for="(item, index) in item.gameList"
                    :key="index"
                    @click="onPlay(item)"
                    @touchmove="Playtouchmove($event, i, index)"
                    @touchstart="Playtouchstart($event, i, index)"
                    @touchend="Playtouchend($event, i, index)"
                  >
                    <div
                      v-if="i == bg_i && bg_index == index && bg_i != -1"
                      style="
                        border-radius: 1rem 0.3rem 0.3rem 0.3rem;
                        background-color: rgba(0, 0, 0, 0.5);
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 100;
                      "
                    ></div>

                    <img
                      class="most_game_img imgs"
                      :src="item.imageSrc"
                      alt=""
                    />
                    <!-- <img class="most_game_img " v-show='!item.showimg' src="@/img/imgload.png" alt="" /> -->
                    <div class="most_game_title">
                      <div class="most_game_text">{{ item.name }}</div>
                      <div class="most_game_sum">
                        {{ formateNumber(item.totalPlayer) }}
                        {{ $t("index.player") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="page_ad"
                id="adx-home-top-container"
                v-if="canOpenOutside && bannerAd"
              >
                <p class="page_ad_title">{{ $t("index.ad") }}</p>
                <div class="page_ad_main">
                  <a href="###" @click="openOutside(bannerAd.url)">
                    <img :src="bannerAd.pic" :alt="bannerAd.title" />
                  </a>
                </div>
              </div>
            </div>

            <div class="" v-if="GameList.length >= 4 && i == 3 && GameList[3]">
              <div class="game_list_box pd_le pd-rg" style="margin-top: 0.5rem">
                <div class="game_list_title">{{ GameList[3].title }}</div>
              </div>
              <div class="DAILY_box">
                <div
                  class="DAILY_list"
                  v-for="(item, index) in GameList[3].gameList"
                  :key="index"
                  @click="onPlay(item)"
                  @touchstart="Playtouchstart($event, 3, index)"
                  @touchend="Playtouchend($event, 3, index)"
                >
                  <!-- v-show="item.showimg ==true"  @load="imgload(3,index)" -->
                  <img class="DAILY_game imgs" :src="item.imageSrc" alt="" />
                  <!-- <img class="DAILY_game " v-show='!item.showimg' src="@/img/imgload.png" alt="" /> -->
                  <div class="DAILY_title">{{ item.name }}</div>
                  <div
                    class="DAILY_btn"
                    :class="
                      3 == bg_i && bg_index == index && bg_i != -1
                        ? 'btn-active'
                        : ''
                    "
                  >
                    {{ $t("index.open") }}
                  </div>
                </div>
              </div>
            </div>

            <div
              class=""
              v-if="
                i == 4 || (i === GameList.length - 1 && GameList.length <= 3)
              "
            >
              <div class="game_list_box pd_le pd-rg">
                <div class="game_list_title">{{ item.title }}</div>
                <div
                  class="game_list_title_btn"
                  @click="RankDetails(GameList[i].gameList)"
                >
                  <!-- src="@/img/more.png" -->
                  <div class="title_btn_text1">{{ $t("index.More") }}</div>
                  <img
                    class="title_btn_img"
                    :src="require('@/img/' + getTheme + '-more.png')"
                    alt=""
                  />
                </div>
              </div>
              <!-- 这个是排行榜的 -->

              <div class="rank_box pd_le pd-rg">
                <template>
                  <div
                    v-for="(item, index) in item.gameList"
                    v-if="index == 1"
                    class="rank_pm"
                    :style="
                      item.backUrl
                        ? `background-image: linear-gradient(135deg,${item.backUrl.first} 0%,${item.backUrl.last} 100%)`
                        : ``
                    "
                    :key="index"
                    @click="onPlay(item)"
                    @touchstart="Playtouchstart($event, i, 0)"
                    @touchend="Playtouchend($event, i, 0)"
                  >
                    <img class="rank_bg" src="@/img/rank1.png" alt="" />
                    <div class="rank_centent">
                      <div class="rank_game">
                        <img
                          class="rank_game_crown"
                          src="@/img/crown2.png"
                          alt=""
                        />
                        <!--  @load="imgload(i,index)" :src="item.showimg&& item.showimg==true?item.ImageSrc :allimg" -->
                        <img
                          class="rank_game_url imgs"
                          :src="item.imageSrc"
                          alt=""
                        />
                        <!-- <img class="rank_game_url" v-if="item.showimg"   @load="imgload(i,index)" :src="item.ImageSrc" alt="" /> -->
                        <!-- <img class="rank_game_url" v-if="!item.showimg" src="@/img/imgload.png" alt="" /> -->
                      </div>
                      <div class="rank_game_name">{{ item.name }}</div>
                      <div class="rank_game_sum">
                        {{ formateNumber(item.totalPlayer) }}
                        {{ $t("index.player") }}
                      </div>
                    </div>
                    <div class="rank_game_btns">
                      <div
                        class="rank_game_btn"
                        :style="
                          i == bg_i && bg_index == 0 && bg_i != -1
                            ? 'background-color:#eeeeee'
                            : ''
                        "
                      >
                        <span
                          :style="
                            item.backUrl ? 'color:' + item.backUrl.first : ''
                          "
                          >{{ $t("index.open") }}</span
                        >
                      </div>
                    </div>
                  </div>
                </template>
                <div
                  class="rank_pm"
                  v-for="(item, index) in item.gameList"
                  v-if="index == 0"
                  :key="index"
                  :style="
                    item.backUrl
                      ? `background-image: linear-gradient(135deg,${item.backUrl.first} 0%,${item.backUrl.last} 100%)`
                      : ``
                  "
                  @click="onPlay(item)"
                  @touchstart="Playtouchstart($event, i, 1)"
                  @touchend="Playtouchend($event, i, 1)"
                >
                  <img class="rank_bg" src="@/img/rank2.png" alt="" />
                  <div class="rank_centent">
                    <div class="rank_game">
                      <img
                        class="rank_game_crown"
                        src="@/img/crown1.png"
                        alt=""
                      />
                      <!-- @load="imgload(i,index)" :src="item.showimg&& item.showimg==true?item.ImageSrc :allimg" -->
                      <img
                        class="rank_game_url imgs"
                        :src="item.imageSrc"
                        alt=""
                      />
                      <!-- <img class="rank_game_url"  v-if="item.showimg"  @load="imgload(i,index)" :src="item.ImageSrc" alt="" /> -->
                      <!-- <img class="rank_game_url"  v-if="!item.showimg" src="@/img/imgload.png" alt="" /> -->
                    </div>
                    <div class="rank_game_name">{{ item.name }}</div>
                    <div class="rank_game_sum">
                      {{ formateNumber(item.totalPlayer) }}
                      {{ $t("index.player") }}
                    </div>
                  </div>
                  <div class="rank_game_btns">
                    <div
                      class="rank_game_btn"
                      :style="
                        i == bg_i && bg_index == 1 && bg_i != -1
                          ? 'background-color:#eeeeee'
                          : ''
                      "
                    >
                      <span
                        :style="
                          item.backUrl ? 'color:' + item.backUrl.first : ''
                        "
                      >
                        {{ $t("index.open") }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  class="rank_pm"
                  v-for="(item, index) in item.gameList"
                  v-if="index == 2"
                  :key="index"
                  :style="
                    item.backUrl
                      ? `background-image: linear-gradient(135deg,${item.backUrl.first} 0%,${item.backUrl.last} 100%)`
                      : ``
                  "
                  @click="onPlay(item)"
                  @touchstart="Playtouchstart($event, i, 2)"
                  @touchend="Playtouchend($event, i, 2)"
                >
                  <img class="rank_bg" src="@/img/rank3.png" alt="" />
                  <div class="rank_centent">
                    <div class="rank_game">
                      <img
                        class="rank_game_crown"
                        src="@/img/crown3.png"
                        alt=""
                      />
                      <!-- @load="imgload(i,index)" :src="item.showimg&& item.showimg==true?item.ImageSrc :allimg" -->
                      <img
                        class="rank_game_url imgs"
                        :src="item.imageSrc"
                        alt=""
                      />
                      <!-- <img class="rank_game_url" v-if="item.showimg" @load="imgload(i,index)"     :src="item.ImageSrc" alt="" />
                    <img class="rank_game_url" v-if='!item.showimg' src="@/img/imgload.png" alt="" /> -->
                    </div>
                    <div class="rank_game_name">{{ item.name }}</div>
                    <div class="rank_game_sum">
                      {{ formateNumber(item.totalPlayer) }}
                      {{ $t("index.player") }}
                    </div>
                  </div>
                  <div class="rank_game_btns">
                    <div
                      class="rank_game_btn"
                      :style="
                        i == bg_i && bg_index == 2 && bg_i != -1
                          ? 'background-color:#eeeeee'
                          : ''
                      "
                    >
                      <span
                        :style="
                          item.backUrl ? 'color:' + item.backUrl.first : ''
                        "
                      >
                        {{ $t("index.open") }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="rank_list pd-rg"
                v-for="(item, index) in item.gameList"
                v-if="index > 2 && index < 7"
                :key="index"
                @click="onPlay(item)"
                @touchstart="Playtouchstart($event, i, index)"
                @touchend="Playtouchend($event, i, index)"
              >
                <div class="rank_list_game">
                  <div class="rank_list_sum">{{ index + 1 }}</div>
                  <div class="rank_list_url">
                    <!-- @load="imgload(i,index)" :src="item.showimg&& item.showimg==true?item.ImageSrc :allimg" -->
                    <img
                      class="rank_list_img imgs"
                      :src="item.imageSrc"
                      alt=""
                    />
                    <!-- <img class="rank_list_img " v-else='!item.showimg' src="@/img/imgload.png" alt="" /> -->
                  </div>
                  <div class="rank_list_text">
                    <div class="rank_game_title">{{ item.name }}</div>
                    <div class="rank_list_player">
                      {{ formateNumber(item.totalPlayer) }}
                      {{ $t("index.player") }}
                    </div>
                  </div>
                </div>
                <div
                  class="rank_list_btn"
                  :class="
                    i == bg_i && bg_index == index && bg_i != -1
                      ? 'btn-active'
                      : ''
                  "
                >
                  {{ $t("index.open") }}
                </div>
              </div>
            </div>

            <div class="" v-if="i == 0 && GameList.length <= 3">
              <div class="game_list_box pd_le pd-rg">
                <div class="game_list_title">{{ GameList[i].title }}</div>
              </div>
              <div class="DAILY_box">
                <template v-for="(item, index) in GameList[i].gameList">
                  <div
                    v-if="index === 8"
                    class="page_ad"
                    id="adx-home-top-container"
                    style="display: none"
                  >
                    <p class="page_ad_title">{{ $t("index.ad") }}</p>
                  </div>
                  <div
                    :key="index"
                    class="DAILY_list"
                    @click="onPlay(item)"
                    @touchstart="Playtouchstart($event, i, index)"
                    @touchend="Playtouchend($event, i, index)"
                  >
                    <!-- v-show="item.showimg ==true"  @load="imgload(2,index)" -->
                    <img class="DAILY_game imgs" :src="item.imageSrc" alt="" />
                    <!-- <img class="DAILY_game " v-show='!item.showimg' src="@/img/imgload.png" alt="" /> -->
                    <div class="DAILY_title">{{ item.name }}</div>
                    <div
                      class="DAILY_btn"
                      :class="
                        2 == bg_i && bg_index == index && bg_i != -1
                          ? 'btn-active'
                          : ''
                      "
                    >
                      {{ $t("index.open") }}
                    </div>
                  </div>
                </template>

                <div
                  class="page_ad"
                  id="adx-home-top-container"
                  style="display: none"
                  v-if="GameList[i].gameList.length <= 8"
                >
                  <p class="page_ad_title">{{ $t("index.ad") }}</p>
                </div>
              </div>
            </div>
          </div>
          <!--GameList.length >= 4 && GameList[1]  -->
          <div class="" v-if="false">
            <div class="game_list_box pd_le">
              <div class="game_list_title">{{ GameList[1].title }}</div>
            </div>
            <div class="CHOICE">
              <div
                class="CHOICE_list"
                v-for="(item, index) in GameList[1].gameList"
                :key="index"
                @click="onPlay(item)"
              >
                <div class="CHOICE_game">
                  <div
                    class="CHOICE_games"
                    :style="
                      item.backUrl
                        ? `background-image: linear-gradient(135deg,${item.backUrl.first} 0%,${item.backUrl.last} 100%)`
                        : ``
                    "
                  >
                    <img class="CHOICE_game_qie" src="@/img/qie.png" alt="" />
                    <div class="CHOICE_centent">
                      <div class="CHOICE_game_url">
                        <!-- v-show="item.showimg ==true"  @load="imgload(1,index)" -->
                        <img
                          class="CHOICE_game_img imgs"
                          :src="item.imageSrc"
                          alt=""
                        />
                        <!-- <img class="CHOICE_game_img " v-show='!item.showimg' src="@/img/imgload.png" alt="" /> -->
                      </div>

                      <div class="CHOICE_game_title">{{ item.name }}</div>
                      <div class="CHOICE_game_sum">
                        {{ formateNumber(item.totalPlayer) }}
                        {{ $t("index.player") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="page_ad"
            id="adx-home-bottom-container"
            style="display: none"
          >
            <p class="page_ad_title">{{ $t("index.ad") }}</p>
          </div>

          <div class="" v-if="GameList[2] && GameList.length >= 4">
            <div class="game_list_box pd_le pd-rg">
              <div class="game_list_title">{{ GameList[2].title }}</div>
            </div>
            <div class="DAILY_box">
              <div
                class="DAILY_list"
                v-for="(item, index) in GameList[2].gameList"
                :key="index"
                @click="onPlay(item)"
                @touchstart="Playtouchstart($event, 2, index)"
                @touchend="Playtouchend($event, 2, index)"
              >
                <!-- v-show="item.showimg ==true"  @load="imgload(2,index)" -->
                <img class="DAILY_game imgs" :src="item.imageSrc" alt="" />
                <!-- <img class="DAILY_game " v-show='!item.showimg' src="@/img/imgload.png" alt="" /> -->
                <div class="DAILY_title">{{ item.name }}</div>
                <div
                  class="DAILY_btn"
                  :class="
                    2 == bg_i && bg_index == index && bg_i != -1
                      ? 'btn-active'
                      : ''
                  "
                >
                  {{ $t("index.open") }}
                </div>
              </div>
            </div>
          </div>

          <!-- 到底部了 -->
          <!--  <div class="more_game">
                  <div class="more_game_height1"></div>
                  <div class="loading" v-if="!isEnd">
                    <img class="loading_img" src="@/img/gif.gif" />
                    <span class="loading_text">{{$t('index.recommend')}}</span>
                  </div >
                  <div v-if="isEnd">
                     {{$t('index.nogame')}}
                  </div>
                  <div class="more_game_height"></div>
				 </div>
			</div> -->
        </div>

        <!-- 修改头像的弹出款  -->
        <!--  <div class="head" v-if="showhead">
        <div class="head_bg"></div>
        <div class="head_box">
          <div class="head_colse" @click="colsename"><img class="head_colse_img" src="@/img/colse.png" alt="" /></div>
          <div class="head_url" @click="selectname">
            <img class="head_img" :src="userheader" alt="" />
            <img class="head_camera" src="@/img/camera.png" alt="" />
          </div>
          <div class="head_name">
            <input v-if="IsName" class="head_input" autofocus="autofocus" @blur="nameblur" @focus="namefocus" v-model="username" type="text" />
            <div v-else class="head_name_box" @click="ShowName">
              <span>{{ username }}</span>
              <img class="head_name_edit" src="@/img/edit.png" alt="" />
            </div>
          </div>
          <div class="head_button" @click="send">{{ $t('index.Save') }}</div>
        </div>
      </div> -->

        <!-- 这个是分享的弹窗      v-if="false"  showShare -->
        <div class="share" v-if="false">
          <div class="head_bg"></div>
          <div class="share_box">
            <div class="share_colse" @click="ColseShare">
              <img class="share_colse_img" src="@/img/colse.png" alt="" />
            </div>
            <div class="share_text">{{ $t("index.Sharegame") }}</div>
            <div class="share_url">
              <img class="share_img" :src="ShareURL" alt="" />
            </div>

            <!--   -->
            <!-- <div class="head_button" @click="SendShare">
            {{ $t("index.Share") }}
          </div> -->
            <!-- 测试代码 -->
            <div class="head_button" @click="SendShare1">bipent://</div>
            <div class="head_button" @click="SendShare2">bip://</div>
            <!--/ 结束-->
          </div>
        </div>

        <img
          style="opacity: 0; width: 0; height: 0"
          src="@/img/gif2.gif"
          alt=""
        />
        <div class="hint" v-if="hintloading">
          <div class="hint_loading_box">
            <img class="hint_loading" src="@/img/gif2.gif" alt="" />
          </div>
        </div>
        <!-- 领取成功提示   -->
        <div class="hint" v-if="ishint">
          <div class="hint_box">
            <div class="hint_url">
              <!-- 成功 -->
              <img
                class="hint_img"
                v-if="hintstate == true"
                src="@/img/successfully.png"
                alt=""
              />
              <!-- 失败 -->
              <img class="hint_img" v-else src="@/img/close.png" alt="" />
            </div>

            <div class="hint_text" v-if="hintstate == true">
              {{ $t("index.success") }}
            </div>
            <div class="hint_text" v-else>{{ $t("index.failed") }}</div>
          </div>
        </div>

        <!-- <transition name="moveR"><name @ret="modelRet" v-if="show"></name></transition> -->
      </div>
    </div>
    <!-- <div
      class="boon"
      :class="navigationbar ? 'boon_active' : ''"
      v-show="selectbar == 2 && headbar"
    >
      <Boon></Boon>
    </div> -->
    <div v-show="selectbar == 3 && headbar" style="height: 100%">
      <Category></Category>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import name from "@/components/name";
import IosIndex from "@/components/iosIndex";
import Boon from "@/components/boon";
import Category from "@/components/category";
import configs from "@/config/config.js";
import navBar from "@/components/nav/navBarIndex";

function get(ts) {
  ts.style.display = "block"; //显示图片
}
export default {
  components: {
    name,
    IosIndex,
    Boon,
    navBar,
    Category,
  },

  data() {
    return {
      headbar: true,

      // 判断是哪个页面
      selectbar: 1,

      isAndroid: true,
      isiOS: false,
      allimg: require("@/img/imgload.png"),
      userheader: "https://cdn.just4fun.sg/resource/avatars/default.png",
      username: "123",
      IsName: false,
      showhead: false,
      show: false,
      bg_i: -1,
      bg_index: -1,
      ishint: false,
      hintstate: false,
      hintloading: false,

      actionlist: "",
      isEnd: false,
      addd: [{}, {}],
      boxshow: false,
      clearpaly: "",

      // 分享开关
      showShare: false,
      ShareURL: "",

      // 导航后退
      navigationbar: false,
      getTheme: "",
      canOpenOutside:
        window.Bridge &&
        window.Bridge.system &&
        window.Bridge.system.openWebView,
    };
  },
  computed: {
    ...mapGetters("game", ["getRecentPlayList", "isPlayList"]),
    ...mapState("game", ["GameList"]),
    ...mapState("user", ["userInfo"]),
    ...mapState("adConfig", ["bannerAd"]),
  },
  created() {
    this.getTheme = configs.getTheme();
    const navigationbar =
      configs.GetQueryString("navigationbar") ||
      this.$route.query.navigationbar;
    if (navigationbar && navigationbar == "true") {
      this.navigationbar = true;
    }

    var u = navigator.userAgent;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // 判断是否在bridge中
    if (window.TgaBridge) {
      this.headbar = false;
    }
    if (window.Bridge) {
      this.headbar = false;
    }
    this.GetGameList();
    var self = this;
    let avatar =
      configs.GetQueryString("avatar") || localStorage.getItem("avatar");
    this.showhead = this.userInfo.first;

    this.userheader = avatar;
    // this.getAdConfig({ $axios: this.$axios });
  },
  mounted() {
    var self = this;
    if (self.isAndroid) {
      window.onbeforeunload = function (e) {
        var e = window.event || e;
        self.hintloading = false;
      };
    } else if (self.isiOS) {
      window.addEventListener("pagehide", function () {
        self.hintloading = false;
      });
    }

    // this.action();
    // 6小时的时间戳
    var timestam = 1000 * 60 * 60 * 6;
    var time = new Date().getTime();
    if (
      localStorage.getItem("ShareGame") &&
      localStorage.getItem("Sharetime")
    ) {
      var Sharetime = JSON.parse(localStorage.getItem("Sharetime"));
      if (time - Sharetime <= timestam) {
        var ShareGame = JSON.parse(localStorage.getItem("ShareGame"));
        self.showShare = true;
        self.ShareURL = ShareGame.imageSrc;
      } else {
        localStorage.removeItem("ShareGame");
        localStorage.removeItem("Sharetime");
      }
    }
  },
  destroyed: function () {
    this.clearViews();
  },
  updated: function () {},

  watch: {
    username(curVal, oldVal) {
      if (curVal.length > 24) {
        this.username = String(curVal).slice(0, 24);
      }
    },
  },
  methods: {
    ...mapActions("game", [
      "ActionList",
      "ActionGameList",
      "ActionGameIdList",
      "changeRecentPlayList",
      "gamePlay",
      "GetShareUrl",
      "openAppLogin",
    ]),
    ...mapActions("user", [
      "UserFinishTask",
      "UserJoinAction",
      "UpdateUserInfo",
    ]),
    ...mapActions("adConfig", ["getAdConfig"]),

    formateNumber(data) {
      return configs.formateNumber(data);
    },

    bar(index) {
      if (localStorage.getItem("txn_id")) {
        this.selectbar = index;
      } else {
        if (index == 2) {
          this.openAppLogin({
            $axios: this.$axios,
            status: true,
          });
        }
      }
    },
    imgload(i, index) {
      var self = this;
      this.GameList[i].gameList[index].showimg = true;
      this.$store.commit("game/setGameallIMG", self.GameList);
      if (i == 4) {
        console.log(this.GameList[i].gameList[index]);
      }
    },

    avatarError(e) {
      e.target.src = "https://cdn.just4fun.sg/resource/avatars/default.png";
    },

    // 点击跳转到排行榜
    async RankDetails(item) {
      localStorage.setItem("RankGame", JSON.stringify(item));

      if (window.Bridge) {
        const res = await window.Bridge.system.getAppConfig();
        // 循环判断主题
        let color = "";
        let titleColor = "";
        for (let i = 0; i < res.theme.length; i++) {
          if (res.theme[i].name == localStorage.getItem("theme")) {
            color = res.theme[i].navigationColor;
            titleColor = res.theme[i].titleColor;
          }
        }

        let url = `${window.location.origin}/#/gamerank`;
        switch (localStorage.getItem("theme")) {
          case "dark-blue":
            color = "#12172a";
            break;
          case "dark":
            color = "#0f0d14";
            break;
          case "candlelight":
            color = "#ffdb0d";
            break;
          case "lavender":
            color = "#9876d0";
            break;
          case "orange":
            color = "#fa9c2a";
            break;
          case "night-blue":
            color = "#213042";
            break;
          default:
            color = "#03a9f5";
            break;
        }

        let goPage = {
          url: url,
          isShowNavigation: true,
          isShowStatusBar: true,
          navigationColor: color,
          statusBarColor: color,
          titleColor: titleColor,
          title: this.$t("rank.title"),
        };
        window.Bridge.system.goPage(goPage);
      } else {
        this.$router.push({
          path: "/gamerank",
        });
      }
    },

    clearViews() {
      var self = this;
      self.hintloading = false;
      clearTimeout(self.clearpaly);
    },
    // 分享关闭
    ColseShare() {
      localStorage.removeItem("ShareGame");
      localStorage.removeItem("Sharetime");
      this.showShare = false;
    },

    // 点击分享
    async SendShare() {
      var ShareGame = JSON.parse(localStorage.getItem("ShareGame"));
      let lang = localStorage.getItem("lang");
      // const data = await this.GetShareUrl({
      //   $axios: this.$axios,
      //   gameId: ShareGame.GameId + '',
      //   lang: lang,
      //   type: 'bip'
      // });
      //
      // var url = 'bipent://send?text=Birlikte+Oynayalım+https://data.just4fun.sg/sb/tga/Game/SharedGoGame?gameId=17&lang=TR'
      // android

      let url =
        "bipent://send?text=Sen+de+bu+eğlenceli+BiP+oyununu+oynamak+ister+misin?+https://prpbipgaming.tvoip.turkcell.com.tr/sb/tga/Game/SharedGoGame?gameId=17&lang=TR&gaminginapp=1";
      if (this.isAndroid) {
        url =
          "bip://send?text=Sen+de+bu+eğlenceli+BiP+oyununu+oynamak+ister+misin?+https://prpbipgaming.tvoip.turkcell.com.tr/sb/tga/Game/SharedGoGame?gameId=17&lang=TR&gaminginapp=1";
      }

      location.href = url;
    },
    async SendShare1() {
      let url =
        "bipent://send?text=Sen+de+bu+eğlenceli+BiP+oyununu+oynamak+ister+misin?+https://prpbipgaming.tvoip.turkcell.com.tr/h5tga4bip/?gameId=78&gaminginapp=1";
      // let url =
      //   "https://prpbipgaming.tvoip.turkcell.com.tr/sb/tga/Game/SharedGoGame?gameId=78&gaminginapp=1";
      location.href = url;
    },
    async SendShare2() {
      let url =
        "bip://send?text=Sen+de+bu+eğlenceli+BiP+oyununu+oynamak+ister+misin?+https://prpbipgaming.tvoip.turkcell.com.tr/h5tga4bip/?gameId=78&gaminginapp=1";
      location.href = url;
    },

    // 获取焦点
    namefocus() {},
    // 失去焦点
    nameblur() {
      var self = this;
      self.IsName = false;
    },
    // 点击显示input
    ShowName() {
      var self = this;
      self.IsName = true;
    },

    selectname() {
      var self = this;
      self.show = true;
    },

    modelRet(data) {
      this.show = data.show;
      if (data.url) {
        this.userheader = data.url;
      }
    },
    shownameModel() {
      this.showhead = true;
      this.username = this.userInfo.name;
      if (this.userInfo.header) {
        this.userheader = this.userInfo.header;
      }
    },

    async colsename() {
      this.showhead = false;
      this.userInfo.first = false;
      const data = await this.UpdateUserInfo({
        $axios: this.$axios,
        nickname: "",
        header: "",
        saved: 0,
      });
    },
    // 点击保存
    async send() {
      var self = this;
      self.hintloading = true;
      const data = await this.UpdateUserInfo({
        $axios: this.$axios,
        nickname: this.username,
        header: this.userheader,
        saved: 1,
      });

      if (data.stateCode == 1) {
        self.hintstate = true;
        this.userInfo.name = this.username;
        this.userInfo.header = this.userheader;
        this.showhead = false;
        this.userInfo.first = false;
      } else {
        self.username = self.userInfo.name;
        this.showhead = false;
        this.userInfo.first = false;
        self.hintstate = false;
      }
      self.hintloading = false;
      self.ishint = true;
      setTimeout(function () {
        self.ishint = false;
      }, 1000);
    },

    Playtouchstart(e, i, index) {
      this.bg_i = i;
      this.bg_index = index;

      this.bg_scrollTop = document.querySelector(".game_main").scrollTop;
    },
    Playtouchend(e, i, index) {
      this.bg_i = -1;
      this.bg_index = -1;
    },
    Playtouchmove(e, i, index) {
      var top = document.querySelector(".game_main").scrollTop;
      if (this.bg_scrollTop - top > 8 || top - this.bg_scrollTop > 8) {
        this.bg_i = -1;
        this.bg_index = -1;
      }
    },
    // 点击跳转到领取详情页
    Clickgame() {
      this.$router.push({
        path: "/activity_get",
        // query: { actionId: self.actionlist.actionId }
      });
    },

    // 切换语言
    // 	   changeLanguage(){
    // 		    if (this.$i18n.locale == 'en') {
    // 		        this.$i18n.locale = 'tr'
    // 		     } else {
    // 		        this.$i18n.locale = 'en'
    // 		     }
    //
    // 		   },

    async action() {
      //获取用户信息列表
      var self = this;

      this.actionlist = await this.ActionList({
        $axios: this.$axios,
      });

      // this.sign();

      // this.$nextTick(function () {
      //   //   console.log('hahha ++++++++++++',this.swiper)
      //   // console.log('44564')
      //     this.swiperOption.init = true
      //   // this.swiper.init();
      // });
      this.boxshow = true;
      this.isEnd = true;
    },

    // 获取游戏的列表
    async GetGameList() {
      var self = this;
      let lang = localStorage.getItem("lang");
      // 判断是否有
      // if (!localStorage.getItem("BIPGameList")) {
      //   const res = await this.ActionGameList({
      //     $axios: this.$axios,
      //     lang: lang
      //   });
      // } else {
      //   const res = await this.ActionGameIdList({
      //     $axios: this.$axios,
      //     lang: lang
      //   });
      //   if (res == false) {
      //     const res = await this.ActionGameList({
      //       $axios: this.$axios,
      //       lang: lang
      //     });
      //   }
      // }
      const res = await this.ActionGameList({
        $axios: this.$axios,
        lang: lang,
      });
      // const res = await this.ActionGameIdList({
      //      $axios: this.$axios,
      //      lang: lang
      //    });
      this.boxshow = true;
      self.isEnd = true;
    },

    // 首次一打开就签到
    async sign() {
      //获取用户参与列表
      var self = this;

      if (!self.actionlist) {
        var actionId = "";
      } else {
        var actionId = self.actionlist.actionId;
      }
      await self.UserFinishTask({
        $axios: self.$axios,
        actionId: actionId,
        taskId: "task01",
        objectId: "",
      });
    },
    // 点击参与活动
    async ClickJoin() {
      var self = this;
      // var kaishitiem = new  Date('2021-01-01').getTime()
      // var tiem = new Date().getTime()
      // console.log('kaishitiemkaishitiem',kaishitiem)

      // console.log('tiemtiemtiemtiem',tiem)
      // if(kaishitiem < tiem){
      this.UserJoinAction({
        $axios: this.$axios,
        actionId: self.actionlist.actionId,
      });
      // }

      this.$router.push({
        path: "/activity",
        query: { actionId: self.actionlist.actionId },
      });
    },
    // 点击去玩游戏
    async onPlay(item) {
      var self = this;
      // 点击去玩就添加数据到缓存
      var time = new Date().getTime();
      localStorage.setItem("ShareGame", JSON.stringify(item));
      localStorage.setItem("Sharetime", JSON.stringify(time));

      this.hintloading = true;
      this.clearpaly = setTimeout(function () {
        self.hintloading = false;
      }, 600000);

      this.changeRecentPlayList({
        $axios: this.$axios,
        recentPlay: item,
        userId: this.userInfo.id,
      });
      // 新版统计
      window.dataKule.push("track", "game", "play-btn", {
        id: item.gameId,
      });
      const res = await this.gamePlay({
        $axios: this.$axios,
        $router: this.$router,
        url: item.playUrl,
        gameId: item.gameId,
        ImageSrc: item.imageSrc,
        $root: this.$root,
      });

      this.hintloading = res;

      // 只要去玩就发送签到
      // await self.UserFinishTask({
      //   $axios: self.$axios,
      //   // self.actionlist.actionId
      //   actionId: 1,
      //   taskId: "task02",
      //   objectId: item.gameId
      // });
    },

    openOutside(url) {
      window.Bridge.system.openWebView({
        url,
      });
    },

    // 开启debug模式
    async onDebug() {
      if (window.Bridge) {
        await window.Bridge.system.setDebug({ state: true });
      }
    },

    // 计算完成度
    calculate(z, s) {
      console.log();
      var sum = (s / z) * 100;
      if (sum > 100) {
        sum = 100;
      }
      return sum;
    },
  },
};
</script>
<style>
.swiperPag {
  display: flex;
  justify-content: center;
}
.swiper-pagination-customs {
  width: 0.3rem;
  height: 0.08rem;
  border-radius: 0.04rem;
  background-color: #f0f2f5;
  margin-right: 0.1rem;
  opacity: 0.5;
}
.swiper-pagination-customs.swiper-pagination-customs-active {
  box-sizing: border-box;
  width: 0.3rem;
  height: 0.08rem;
  border-radius: 0.04rem;
  background-color: #ffffff;
  opacity: 1;
}
</style>

<style scoped="scoped">
.bip {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.bar_box {
  width: 100%;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
}
.bar_box_active {
  top: 1.5rem;
}

.bip_bar_box {
  height: 1.2rem;
  width: 100%;
  display: flex;
  background-color: var(--bg);
}

.bip_bar {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* position: relative; */
}
.bip_bar_tiao {
  height: 0.07rem;
  margin-top: 0.2rem;
  /* position: absolute; */
  /* bottom: 0.1rem; */
  /* left: calc((100% - 0.71rem) / 2); */
}
.bip_bar_text {
  font-size: 0.42rem;
  color: var(--titleColor);
  font-weight: bold;
}
.bip_bar_active .bip_bar_tiao {
  width: 0.71rem;
  height: 0.07rem;
  background-color: var(--titleTiao);
  border-radius: 0.03rem;
}
.bip_bar_active .bip_bar_text {
  color: var(--titleColorActive);
  font-size: 0.42rem;
  font-weight: bold;
}

.main {
  width: 100%;
  height: 100%;
}
.game_box {
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.game_nav {
  background-color: #03a9f5;
  width: 100%;
  height: 1.63rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.game_nav_text {
  position: relative;
  z-index: 2;
  font-size: 0.56rem;
  color: #ffffff;
}
.game_nav_img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
/* 搜索样式 */
.seek_box {
  box-sizing: border-box;
  width: 100%;
  padding: 0.42rem 0.21rem 0 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.seek_box_top {
  padding-top: 1.32rem;
  /* padding-top: 0.32rem; */
}
.seek_box_top_active {
  margin-top: 1.6rem;
}
.seek_box_top_active .seek_box {
  padding-top: 0;
}
.seek_box_top_active .seek_box_top {
  padding-top: 1.2rem;
}
.seek {
  margin-right: 0.4rem;
  box-sizing: border-box;
  /* width: 8.8rem; */
  width: 100%;
  height: 0.9rem;
  background-color: var(--seekBackground);
  border-radius: 0.45rem;
  padding-left: 0.3rem;
  display: flex;
  align-items: center;
}
.seek_url {
  display: flex;
  align-items: center;
}
.seek_img {
  width: 0.44rem;
  height: 0.45rem;
}
.seek_text {
  color: #cccccc;
  font-size: 0.42rem;
  margin-left: 0.33rem;
}
.user {
  width: 1rem;
  height: 1rem;
  margin-right: 0.4rem;
}
.user_img {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}
/* 活动图 */
.swiper_box {
  width: 10.24rem;
  height: 4.6rem;
  position: relative;
  margin: 0.5rem auto 0.85rem;
}
.swiper {
  box-sizing: border-box;
  width: 10.24rem;
  height: 4.6rem;
  position: relative;
  z-index: 1;
}
.swiper_slide {
  width: 100%;
  height: 100%;
}
.game_activity {
  position: relative;
  width: 100%;
  height: 4.6rem;
  border-radius: 0.2rem;
  /* margin: 0.5rem auto 0.85rem; */
}
.game_activity_img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 0.2rem;
  z-index: 1;
}
.game_activity_box {
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  left: 0;
  top: 0;
  padding-left: 0.5rem;
  padding-top: 1.19rem;
}
.game_activity_title {
  font-size: 0.6rem;
  color: #ffffff;
  font-weight: bold;
}
.game_activity_text {
  margin-top: 0.1rem;
  font-size: 0.34rem;
  color: #ffffff;
}
.game_activity_button {
  display: inline-block;
  box-sizing: border-box;
  padding: 0.23rem 0.3rem 0.22rem 0.29rem;
  /* width: 2.4rem; */
  /* height: 0.72rem; */
  background-color: #ffffff;
  box-shadow: inset 0px -0.06rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.1rem;
  color: #1b1b1b;
  font-size: 0.36rem;
  margin-top: 0.6rem;
  /* display: flex;
      justify-content: center;
      align-items: center; */
}
/* 已经参加的状态 */
.game_activity_join {
  box-sizing: border-box;
  padding: 0.4rem 0 0 0.48rem;
  position: relative;
  z-index: 2;
  left: 0;
  top: 0;
}
.game_activity_join_title {
  color: #ffffff;
  font-size: 0.3rem;
}
.game_activity_join_rank_box {
  margin-top: 0.2rem;
  display: flex;
  align-items: center;
}
.game_activity_join_rank_url {
  width: 0.76rem;
  height: 0.69rem;
}
.game_activity_join_rank_img {
  width: 0.76rem;
  height: 0.69rem;
  object-fit: cover;
}
.game_activity_join_rank {
  margin-left: 0.2rem;
  font-size: 0.48rem;
  color: #ffffff;
}
.game_activity_join_PRIZE {
  margin-top: 0.4rem;
  color: #ffffff;
  font-size: 0.3rem;
}
.game_activity_PRIZE {
  margin-top: 0.1rem;
  position: relative;
  right: 0;
  height: 0.42rem;
  width: 2.5rem;
  display: flex;
  align-items: center;
}
.game_activity_PRIZE_tiao_box {
  width: 2.5rem;
  height: 0.1rem;
  background-color: #fbd38e;
  position: relative;
  top: 0;
  left: 0;
  border-radius: 0.05rem;
}
.game_activity_PRIZE_tiao {
  position: absolute;
  background-color: #ffe400;
  width: 1rem;
  height: 100%;
  border-radius: 0.05rem;
}
.game_activity_PRIZE_url {
  position: absolute;
  top: -0.66rem;
  right: -0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
}
.game_activity_PRIZE_img {
  width: 1.5rem;
  height: 1.5rem;
}

.game_activity_PRIZE_button {
  width: 1.6rem;
  height: 0.72rem;
  background-color: #ffffff;
  box-shadow: inset 0px -0.06rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.1rem;
  color: #1b1b1b;
  font-size: 0.36rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.4rem;
}
/* 这个是玩过的游戏列表 */
.recent_play {
  box-sizing: border-box;
  padding-left: 0.3rem;
  width: 100%;
  margin-bottom: 0.25rem;
  margin-top: 0.8rem;
}
@media screen and (min-width: 1000px) {
  .recent_play,
  .bar_box,
  .seek,
  .seek,
  .game {
    max-width: 800px !important;
    margin: 0 auto !important;
  }
}
@media screen and (min-width: 1000px) {
  .bar_box {
    width: 800px !important;
    left: unset !important;
  }
}
.recent_play_title {
  font-size: 0.48rem;
  color: var(--listTitle);
  font-weight: bold;
}
.recent_play_box {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  margin-right: 0.42rem;
  overflow: auto;
}
.recent_play_game {
  margin-top: 0.49rem;
}
.recent_play_img {
  width: 1.55rem;
  height: 1.55rem;
  background-color: #e0e2e6;
  border-radius: 0.2rem;
  margin-right: 0.42rem;
}
.game {
  box-sizing: border-box;
}
.pd-rg {
  padding-right: 0.4rem;
}
.pd_le {
  padding-left: 0.4rem;
}
.game_list_box {
  margin-top: 0.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.game_list_title {
  font-weight: bold;
  font-size: 0.48rem;
  color: var(--listTitle);
}
.game_list_title_btn {
  height: 0.6rem;
  padding: 0rem 0.2rem;
  display: flex;
  align-items: center;
  background-image: var(--rankBtn);
  border-radius: 0.3rem;
}
.title_btn_text1 {
  height: 100%;
  font-family: Roboto-Regular;
  color: var(--rankBtnColor);
  font-size: 0.3rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.02rem;
}
.title_btn_img {
  margin-left: 0.14rem;
  width: 0.08rem;
  height: 0.16rem;
}
.most_box {
  margin-top: 0.4rem;
  overflow-y: hidden;
  overflow-x: auto;
  display: flex;
  width: 100%;
  height: 4.5rem;
}
.most_game_box {
  height: 4.5rem;
  display: flex;
  /* align-items: flex-end; */
}
.most_game {
  width: 3.3rem;
  height: 4rem;
  background-color: #ffffff;
  border-radius: 1rem 0.3rem 0.3rem 0.3rem;
  position: relative;
  top: 0;
  left: 0;
  margin-right: 0.39rem;
}
.most_box .most_game:nth-of-type(1) {
  margin-left: 0.39rem;
}

.most_game_img {
  object-fit: cover;
  border-radius: 1rem 0.3rem 0.3rem 0.3rem;
  width: 3.3rem;
  height: 4rem;
}
.most_game_title {
  width: 100%;
  height: 1.3rem;
  background-color: rgba(27, 27, 27, 0.35);
  position: absolute;
  bottom: 0rem;
  left: 0;
  border-radius: 0 0 0.3rem 0.3rem;
  padding-left: 0.25rem;
}
.most_game_text {
  box-sizing: border-box;
  padding-top: 0.15rem;
  font-size: 0.42rem;
  font-weight: bold;
  color: #ffffff;
  width: 2.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.most_game_sum {
  box-sizing: border-box;
  font-size: 0.3rem;
  color: #eeeeee;
  padding-top: 0.1rem;
}
.rank_box {
  margin-top: 2.33rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.rank_box .rank_pm:nth-of-type(1) {
  width: 3.15rem;
  height: 3.8rem;
  border-radius: 0.3rem;
  background-image: linear-gradient(45deg, #ff5671 0%, #ff1038 100%);
  position: relative;
}
.rank_box .rank_pm:nth-of-type(2) {
  width: 3.15rem;
  height: 4.3rem;
  border-radius: 0.3rem;
  background-image: linear-gradient(45deg, #fea700 0%, #fec200 100%);
  position: relative;
}
.rank_box .rank_pm:nth-of-type(3) {
  width: 3.15rem;
  height: 3.3rem;
  border-radius: 0.3rem;
  background-image: linear-gradient(45deg, #0092f2 0%, #019aff 100%);
  box-shadow: 0px 0px 16px 1px rgba(15, 21, 69, 0.09);
  position: relative;
}
.rank_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.rank_centent {
  position: relative;
  z-index: 2;
  top: -1.99rem;
}

.rank_game {
  position: relative;
  /* top: -1.6rem; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rank_game_url {
  margin-top: 0.16rem;
  width: 2.02rem;
  height: 2.02rem;
  /* background-color: #ffd245; */
  border-radius: 0.3rem;
  border: solid 0.05rem #eeeeee;
  object-fit: cover;
}
.rank_game_crown {
  width: 0.87rem;
  height: 0.58rem;
}

.rank_box .rank_pm:nth-of-type(1) .rank_game_name {
  margin: 0.4rem auto 0;
}

.rank_box .rank_pm:nth-of-type(2) .rank_game_name {
  margin: 0.6rem auto 0;
}

.rank_box .rank_pm:nth-of-type(3) .rank_game_name {
  margin: 0.15rem auto 0;
}
.rank_game_name {
  color: #ffffff;
  font-size: 0.42rem;
  width: 2.8rem;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.rank_game_sum {
  margin: 0.08rem auto 0;
  font-size: 0.3rem;
  color: #eeeeee;
  /* width: 2.3rem; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.rank_game_btns {
  width: 100%;
  position: absolute;
  z-index: 2;
  bottom: 0.3rem;
  left: 0;
}
.rank_game_btn {
  width: 2.21rem;
  height: 0.76rem;
  background-color: #ffffff;
  /* 	box-shadow: 0px 0.1rem 0.1rem 0px
			#f2aa00; */
  border-radius: 0.38rem;
  font-size: 0.36rem;

  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.rank_game_btn_active {
  background-color: #eeeeee;
}
.rank_box .rank_pm:nth-of-type(1) .rank_game_btn {
  color: #ff3455;
}

.rank_box .rank_pm:nth-of-type(2) .rank_game_btn {
  color: #feb300;
}

.rank_box .rank_pm:nth-of-type(3) .rank_game_btn {
  color: #0097f9;
}

.rank_list {
  margin-top: 0.57rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.rank_list_game {
  display: flex;
  align-items: center;
}
.rank_list_sum {
  width: 1.12rem;
  text-align: center;
  font-family: "DINENGSCHRIFTSTD";

  color: var(--rankSumColor);
  font-size: 0.74rem;
}

.rank_list_img {
  width: 1.79rem;
  height: 1.79rem;
  border-radius: 0.3rem;
  border: solid 0.05rem #eeeeee;
}
.rank_list_text {
  margin-left: 0.3rem;
}
.rank_game_title {
  font-size: 0.42rem;
  color: var(--rankColor);
  font-weight: bold;
  width: 4.7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rank_list_player {
  margin-top: 0.2rem;
  font-size: 0.3rem;
  color: #999999;
}

.rank_list_btn {
  width: 1.81rem;
  height: 0.76rem;
  background-color: var(--rankBackgroundBtn);
  border-radius: 0.38rem;
  color: var(--rankColorBtn);
  font-size: 0.36rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.CHOICE {
  margin-top: 0.71rem;
  display: flex;
  width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  height: 4.1rem;
}
.CHOICE_list {
  height: 3.5rem;
  display: flex;
  align-items: flex-end;
}
.CHOICE_game {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.CHOICE_games {
  position: relative;
  width: 2.7rem;
  height: 2.71rem;

  /* margin-right: 0.3rem; */
  border-radius: 0 0 0.15rem 0.15rem;
}
.CHOICE .CHOICE_games:nth-of-type(1) {
  margin-left: 0.4rem;
}
.CHOICE_game_qie {
  width: 2.7rem;
  height: 2.8rem;
  position: absolute;
  top: -0.1rem;
  left: 0;
  z-index: 1;
}
.CHOICE_centent {
  position: relative;
  z-index: 2;
  top: -0.76rem;
}

.CHOICE_game_url {
  border-radius: 0.3rem;
  display: flex;
  justify-content: center;
}

.CHOICE_game_img {
  margin: 0 auto;
  width: 1.94rem;
  height: 1.94rem;
  border-radius: 0.3rem;
  border: solid 0.05rem #eeeeee;
}
.CHOICE_game_title {
  text-align: center;
  width: 2.25rem;
  color: #ffffff;
  font-size: 0.42rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0.2rem auto 0;
  font-weight: bold;
}
.CHOICE_game_sum {
  margin: 0 auto;
  width: 2.25rem;
  color: #eeeeee;
  font-size: 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0.1rem auto 0;
  text-align: center;
}

.DAILY_box {
  margin-top: 0.49rem;
  padding: 0 0.19rem;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}

.DAILY_list {
  width: calc(100% / 4);
  display: flex;
  flex-direction: column;

  align-items: center;
  margin-bottom: 0.59rem;
}
.DAILY_game {
  width: 2rem;
  height: 2rem;
  border-radius: 0.3rem;
  object-fit: cover;
}
.DAILY_title {
  margin-top: 0.2rem;
  text-align: center;
  width: 2.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--indexListColor);
  font-size: 0.36rem;
  font-weight: bold;
}
.DAILY_btn {
  margin-top: 0.35rem;
  width: 1.81rem;
  height: 0.76rem;
  background-color: var(--rankBackgroundBtn);
  border-radius: 0.37rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.36rem;
  color: var(--rankColorBtn);
}
.btn-active {
  color: var(--rankColorBtnActive);
  background-color: var(--rankBackgroundBtnActive);
}

.more_game {
  box-sizing: border-box;
  font-size: 0.25rem;
  width: 100%;
  text-align: center;
  color: #000000;
  /* padding-top: 0.41rem; */
  /* margin-top: 0.41rem;
       margin-bottom: 1.50rem; */
  opacity: 0.3;
  background-color: white;
}
.more_game_height {
  width: 100%;
  height: 2.16rem;
  background-color: white;
}
.more_game_height1 {
  width: 100%;
  height: 0.6rem;
  background-color: white;
}

.game_select_ishow {
  height: 1.6rem;
  /* font-size: 0;
       height: 1rem; */
  display: flex;
  align-items: flex-end;
  box-sizing: border-box;
  width: 100%;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  position: fixed;
  justify-content: space-between;
  z-index: 2;
  top: 5.5rem;
  left: 0;
  background-color: white;
  padding-bottom: 0.41rem;
}
/* 页面加载 */
.loading {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
}
.loading_img {
  width: 0.45rem;
  height: 0.45rem;
  margin-right: 0.2rem;
}

/* 头像修改 */
.head {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.head_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.head_box {
  position: relative;
  z-index: 2;
  width: 7.6rem;
  height: 6.9rem;
  background-color: #ffffff;
  border-radius: 0.45rem;
}
.head_url {
  position: relative;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0.9rem auto 0;
}
.head_img {
  box-sizing: border-box;
  object-fit: cover;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 0.06rem solid #ffffff;
  box-shadow: 0px 0.07rem 0.15rem 0px rgba(0, 0, 0, 0.2);
}
.head_camera {
  /* box-shadow: 0px 0.07rem 0.15rem 0px
				rgba(0, 0, 0, 1); */
  width: 0.85rem;
  height: 0.85rem;
  position: absolute;
  bottom: -0.2rem;
  right: 0;
}
.head_colse {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.29rem 0.24rem;
}
.head_colse_img {
  width: 0.73rem;
  height: 0.73rem;
}
.head_name {
  margin-top: 0.5rem;
}
.head_input {
  font-size: 0.48rem;
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
}
.head_name_box {
  text-align: center;
}
.head_name_edit {
  width: 0.4rem;
  height: 0.38rem;
}
.head_button {
  margin: 0.7rem auto 0;
  width: 6.01rem;
  height: 1.21rem;
  background-color: #03a9f5;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 0.42rem;
  /** 用于bip测试分享用，测试好后需要删除 */
  display: inline-block;
  width: 3rem;
  text-align: center;
  line-height: 1.21rem;
  /** 测试代码结束 */
}

.moveR-enter-active,
.moveR-leave-active {
  transition: all 0.1s linear;
  transform: translateX(0);
}
.moveR-enter,
.moveR-leave {
  transform: translateX(100%);
}
.moveR-leave-to {
  transform: translateX(100%);
}

/* 提示语 */
.hint {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: rgba(0,0,0,0.8); */
  color: white;
  /* background:  linear-gradient(-45deg,#644282,#262851); */
}
.hint_box {
  box-sizing: border-box;
  width: 4.4rem;
  height: 4.4rem;
  /* padding: 0.83rem 0; */
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 0.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.hint_url {
  display: flex;
  justify-content: center;
}
.hint_img {
  width: 1.2rem;
  height: 1.2rem;
}
.hint_text {
  margin-top: 0.4rem;
  font-size: 0.36rem;
  /* padding: 0.1rem 0.3rem; */
  /* background-color: rgba(0,0,0,0.8); */
  border-radius: 0.3rem;
  text-align: center;
}

.hint_loading_box {
  width: 3rem;
  height: 3rem;
  /* background-color: rgba(0, 0, 0, 0.8); */
  /* border-radius: 0.4rem; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.hint_loading {
  width: 3rem;
  height: 3rem;
  opacity: 0.8;
}

.load_box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.load_box_bg {
  width: 2rem;
  height: 2rem;
}
.load_box_img {
  width: 100%;
  height: 100%;
}

.share {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.share_box {
  position: relative;
  z-index: 2;
  width: 7.6rem;
  height: 8rem;
  background-color: #ffffff;
  border-radius: 0.45rem;
}
.share_text {
  margin-top: 1.2rem;
  font-size: 0.48rem;
  color: #1b1b1b;
  padding: 0 1.2rem;
  text-align: center;
}
.share_url {
  position: relative;
  width: 2.18rem;
  height: 2.18rem;
  margin: 0.66rem auto 0;
}
.share_img {
  box-sizing: border-box;
  object-fit: cover;
  width: 2.18rem;
  height: 2.18rem;
  border-radius: 0.2rem;
  border: 0.06rem solid #ffffff;
  box-shadow: 0px 0.07rem 0.15rem 0px rgba(0, 0, 0, 0.2);
}

.share_colse {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.29rem 0.24rem;
}
.share_colse_img {
  width: 0.73rem;
  height: 0.73rem;
}

.share_input {
  font-size: 0.48rem;
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
}

.share_button {
  margin: 0.85rem auto 0;
  width: 6.01rem;
  height: 1.21rem;
  background-color: #03a9f5;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 0.42rem;
}
.boon {
  margin-top: 1.5rem;
  width: 100%;
  height: calc(100% - 1.5rem);
  overflow: auto;
  position: relative;
}
.boon_active {
  margin-top: 3rem;
  height: calc(100% - 3rem);
}
.page_ad {
  width: 100%;
  margin-bottom: 0.59rem;
}
.page_ad_title {
  text-align: center;
  font-size: 0.3rem;
  color: #666;
  margin-bottom: 0.1rem;
}
.page_ad_main {
  padding: 0 0.19rem;
}
.page_ad_main img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/androidIndex.vue